module.exports = __webpack_public_path__ + "peng_login_left.png?863f42ff3b70f6ddb0a8c0ebfbf9e243";